import CacheBase2 from '../../services/engines/CacheBase2';

const _name = 'UserStateCache2';

class UserStateCache2 extends CacheBase2 {
    /**
     * Upsert a single state entry by RK.
     * @param {object} entry - UserState2
     */
    upsert = (entry) => {
        this.delete(entry.rk);
        this._items.push(entry);
    };

    /**
     * Upsert an array of state entries.
     * @param {object[]} entries
     */
    upsertAll = (entries) => {
        entries.forEach((e) => this.upsert(e));
    };

    /**
     * Returns all entries for the current tab and user.
     * @returns {object[]}
     */
    getByTabId = () => {
        return this._items.filter((e) => e.tabId === this.getTabId() && e.uid === this.getUid());
    };

    /**
     * Returns a single entry by name for the current tab and user, or null.
     * @param {string} name
     * @returns {object|null}
     */
    getByTabIdAndName = (name) => {
        return this._items.find((e) => e.tabId === this.getTabId() && e.uid === this.getUid() && e.name === name) ?? null;
    };

    /**
     * Returns the value for a named entry for the current tab and user, or null.
     * @param {string} name
     * @returns {string|null}
     */
    getValue = (name) => {
        return this.getByTabIdAndName(name)?.value ?? null;
    };
}

const userStateCache2 = new UserStateCache2();
export default userStateCache2;
